import styled from "@emotion/styled";

export const AssetItem = styled.span`
  display: flex;
  align-items: center;
  padding: 20px;
  svg {
    width: 25px;
    height: 25px;
    margin-right: 12px;
  }
`;
